import { JobStatus, ListArgs } from '../api';
import {
	debounceTime,
	distinctUntilChanged,
	map,
	skip,
	startWith,
} from 'rxjs/operators';

import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';

export const BACKSPACE_KEY = 'Backspace';

export const americanAndCanadianStateCodes = [
	'AK',
	'AL',
	'AR',
	'AS',
	'AZ',
	'CA',
	'CO',
	'CT',
	'DC',
	'DE',
	'FL',
	'GA',
	'GU',
	'HI',
	'IA',
	'ID',
	'IL',
	'IN',
	'KS',
	'KY',
	'LA',
	'MA',
	'MD',
	'ME',
	'MI',
	'MN',
	'MO',
	'MS',
	'MT',
	'NC',
	'ND',
	'NE',
	'NH',
	'NJ',
	'NM',
	'NV',
	'NY',
	'OH',
	'OK',
	'OR',
	'PA',
	'PR',
	'RI',
	'SC',
	'SD',
	'TN',
	'TX',
	'UT',
	'VA',
	'VI',
	'VT',
	'WA',
	'WI',
	'WV',
	'WY',
	// Canadian Provinces
	'AB',
	'BC',
	'MB',
	'NB',
	'NL',
	'NS',
	'NT',
	'NU',
	'ON',
	'PE',
	'QC',
	'SK',
	'YT',
];

export const AMERICANANDCANADIANSTATE_MAP_ABBREVIATION = [
	{ code: 'AL', name: 'Alabama' },
	{ code: 'AK', name: 'Alaska' },
	{ code: 'AZ', name: 'Arizona' },
	{ code: 'AR', name: 'Arkansas' },
	{ code: 'CA', name: 'California' },
	{ code: 'CO', name: 'Colorado' },
	{ code: 'CT', name: 'Connecticut' },
	{ code: 'DC', name: 'District of Columbia' },
	{ code: 'DE', name: 'Delaware' },
	{ code: 'FL', name: 'Florida' },
	{ code: 'GA', name: 'Georgia' },
	{ code: 'HI', name: 'Hawaii' },
	{ code: 'ID', name: 'Idaho' },
	{ code: 'IL', name: 'Illinois' },
	{ code: 'IN', name: 'Indiana' },
	{ code: 'IA', name: 'Iowa' },
	{ code: 'KS', name: 'Kansas' },
	{ code: 'KY', name: 'Kentucky' },
	{ code: 'LA', name: 'Louisiana' },
	{ code: 'ME', name: 'Maine' },
	{ code: 'MD', name: 'Maryland' },
	{ code: 'MA', name: 'Massachusetts' },
	{ code: 'MI', name: 'Michigan' },
	{ code: 'MN', name: 'Minnesota' },
	{ code: 'MS', name: 'Mississippi' },
	{ code: 'MO', name: 'Missouri' },
	{ code: 'MT', name: 'Montana' },
	{ code: 'NE', name: 'Nebraska' },
	{ code: 'NV', name: 'Nevada' },
	{ code: 'NH', name: 'New Hampshire' },
	{ code: 'NJ', name: 'New Jersey' },
	{ code: 'NM', name: 'New Mexico' },
	{ code: 'NY', name: 'New York' },
	{ code: 'NC', name: 'North Carolina' },
	{ code: 'ND', name: 'North Dakota' },
	{ code: 'OH', name: 'Ohio' },
	{ code: 'OK', name: 'Oklahoma' },
	{ code: 'OR', name: 'Oregon' },
	{ code: 'PA', name: 'Pennsylvania' },
	{ code: 'PR', name: 'Puerto Rico' },
	{ code: 'RI', name: 'Rhode Island' },
	{ code: 'SC', name: 'South Carolina' },
	{ code: 'SD', name: 'South Dakota' },
	{ code: 'TN', name: 'Tennessee' },
	{ code: 'TX', name: 'Texas' },
	{ code: 'UT', name: 'Utah' },
	{ code: 'VT', name: 'Vermont' },
	{ code: 'VA', name: 'Virginia' },
	{ code: 'WA', name: 'Washington' },
	{ code: 'WV', name: 'West Virginia' },
	{ code: 'WI', name: 'Wisconsin' },
	{ code: 'WY', name: 'Wyoming' },
];

export const phoneMask = [
	'(',
	/[1-9]/,
	/\d/,
	/\d/,
	')',
	' ',
	/\d/,
	/\d/,
	/\d/,
	'-',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
];

export const QUOTE_STATUSES = [
	JobStatus.CustomerEntry,
	JobStatus.Reviewing,
	JobStatus.Submitted,
];

export const SERVICE_TYPE = {
	Flagging: 0,
	Monitoring: 1,
	HighwayProtector: 3,
};

export const getAllListArgs: ListArgs = {
	pageNumber: 0,
	pageSize: -1,
	searchText: '',
	sortCriteria: [],
};

export const FieldWorkerTypeId = {
	RwicTypeId: 0,
	SupervisorTypeId: 1,
	ManagerTypeId: 2,
	DirectorTypeId: 3,
	SupportTypeId: 4,
};

export const FilledOutFormStatusIds = {
	AssignedId: 0,
	InProgressId: 1,
	SubmittedId: 2,
	ChangesRequiredId: 3,
	ResubmittedId: 6,
	ApprovedId: 4,
	RejectedId: 5,
};

export const FCVMStatusKeys = {
	missing: 'missing',
	needsReview: 'needsReview',
	revision: 'revision',
	approved: 'approved',
};

export const defaultPageSize = 10;

export const FORM_STATUS_COLOR_MAP = new Map<number, string>([
	[FilledOutFormStatusIds.SubmittedId, 'primary-text'],
	[FilledOutFormStatusIds.ChangesRequiredId, 'warn-text'],
	[FilledOutFormStatusIds.ApprovedId, 'success-text'],
	[FilledOutFormStatusIds.RejectedId, 'warn-text'],
]);

export const FORM_STATUS_COLORS = {
	[FilledOutFormStatusIds.SubmittedId]: 'primary-text',
	[FilledOutFormStatusIds.ChangesRequiredId]: 'warn-text',
	[FilledOutFormStatusIds.ApprovedId]: 'success-text',
	[FilledOutFormStatusIds.RejectedId]: 'warn-text',
};

export const errorTypes = {
	FRIENDLY_MESSAGE_CODE: 450,
};

export const SNACK_BAR_DISPLAY_LENGTH = 2000;

export const BASE_64_PREFIX = 'data:image/jpeg;base64, ';

export const DEFAULT_TRAIN_IMG_PATH = '../../../admin-assets/Train_Logo.png';

// The purpose of skip 1 is to stop a flicker that happens when the form is first set.
export const pristineOrInvalid = (
	formGroup: AbstractControl
): Observable<boolean> => {
	return formGroup.valueChanges.pipe(
		skip(1),
		debounceTime(500),
		distinctUntilChanged(),
		startWith(false),
		map(() => formGroup.pristine || formGroup.invalid)
	);
};

export const feetMask = (s: string) => {
	let mask: any[] = [];

	if (s) {
		let feet: number;

		if (s.length > 4) {
			feet = parseInt(s.slice(0, -4), 10);
		} else {
			feet = parseInt(s, 10);
		}

		if (feet > 999) {
			mask = [/\d?/, /\d?/, /\d?/, /\d?/, ' feet'];
		}
		if (feet > 99 && feet < 1000) {
			mask = [/\d?/, /\d?/, /\d?/, ' feet'];
		}
		if (feet > 9 && feet < 100) {
			mask = [/\d?/, /\d?/, ' feet'];
		}
		if (feet > 1 && feet < 10) {
			mask = [/\d?/, ' feet'];
		}
		if (feet === 1) {
			mask = [/\d?/, ' foot'];
		}
	}

	return mask;
};

export const hoursMask = (s: string) => {
	let mask: any[] = [];

	if (s) {
		let hours: number;

		if (s.length > 5) {
			hours = parseInt(s.slice(0, -5), 10);
		} else {
			hours = parseInt(s, 10);
		}

		if (hours > 9) {
			mask = [/\d?/, /\d?/, ' hours'];
		}
		if (hours > 1 && hours < 10) {
			mask = [/\d?/, ' hours'];
		}
		if (hours === 1) {
			mask = [/\d?/, ' hour'];
		}
	}

	return mask;
};

export const dateParamFormat = 'YYYY-MM-DD';

export const timeMask = (s: string) => {
	let mask: any[] = [];
	if (s) {
		mask = [/\d?/, /\d?/, ':', /\d?/, /\d?/];
	}

	return mask;
};

export const TIMEOUT = 15000;
